import { createStateSelectorHook } from 'src/lib/sweetState';
import { DocumentStore } from '../../../../../../store';

const useDocumentViewState = createStateSelectorHook(DocumentStore, [
  'detailsPanelVisibleForInstanceId',
]);

export const useIsVisibleOnDetailsPanel = (id) => {
  const { detailsPanelVisibleForInstanceId } = useDocumentViewState();
  return detailsPanelVisibleForInstanceId === id;
};
